<template>
  <div
    class="with-sidebar"
    :style="{
      '--gutter': gutter,
      '--sidebar-target-width': targetWidth,
      '--sidebar-content-min-width': contentMinWidth,
    }"
    :data-side="side"
    :data-reverse="reverse"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    gutter: {
      type: String,
      required: false,
      default: "",
    },
    targetWidth: {
      type: String,
      required: false,
      default: "",
    },
    contentMinWidth: {
      type: String,
      required: false,
      default: "",
    },
    side: {
      type: String,
      required: false,
      default: "",
    },
    reverse: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {},
};
</script>

<style lang="scss">
.with-sidebar {
  display: flex;
  flex-wrap: wrap;
  gap: var(
    --gutter,
    var(--global-space)
  ); // Set a space for gap with default size as a fallback

  // Sidebar
  // The size is defined by the content.
  // A flex-basis could be added to use a fixed size for the sidebar. E.g. flex-basis: 20rem;
  & > :first-child {
    flex-grow: 1;
    flex-basis: var(--sidebar-target-width, 20rem);
  }

  // Not-Sidebar
  & > :last-child {
    flex-basis: 0;
    flex-grow: 999;
    min-width: var(
      --sidebar-content-min-width,
      50%
    ); // This is a "container query" and defined the point where the layout switches to vertical
  }

  /* Exceptions */

  // Exception to position the sidebar right. The elements need to be changed in the html markup.
  // Switched :first- and :last-child.
  &[data-side="right"] {
    // Sidebar
    & > :last-child {
      flex-grow: 1;
      flex-basis: var(--sidebar-target-width, 20rem);
      min-width: unset;
    }

    // Not-Sidebar
    & > :first-child {
      flex-basis: 0;
      flex-grow: 999;
      min-width: var(--sidebar-content-min-width, 50%);
    }
  }

  // Exception to reverse the horizontal order with flexbox. No need to change the elements order in markup.
  // This has no effect on the vertical order if the elements placed atop each other.
  &[data-reverse="true"] {
    flex-direction: row-reverse;
  }
}
</style>
